// import moment from "moment";
// import { DATE_FORMAT } from "src/config";

// const parseDate = (arg, inputFormat = "YYYY-MM-DD") =>
//   // arg ? moment(arg, inputFormat).format(DATE_FORMAT) : "-";
//   arg ? moment.utc(arg, inputFormat).format(DATE_FORMAT) : "-";
//   // arg ? moment.utc(arg, inputFormat).tz("America/New_York").format(DATE_FORMAT) : "-";


// export default parseDate;





// import moment from "moment";

// const parseDate = (arg) => {
//   if (!arg) return "-";

//   const dateStr = arg.split(" ")[0]; 
  
//   return moment(dateStr, "MM/DD/YY").format("DD MMM YYYY"); 
// };

// export default parseDate;


//----------------------- last comment 15 0ct 2025-----------------
// import moment from 'moment-timezone';
// import { DATE_FORMAT } from "src/config";

// const parseDate = (arg) => {
//   if (!arg) return "-";

//   let parsedDate;
//   let formattedDate;

//   // Detect format and parse accordingly
//   if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(arg)) {
//     // MM/DD/YYYY hh:mm:ss
//     parsedDate = moment(arg, "MM/DD/YYYY hh:mm:ss");
//   } else if (/^\d{2}\/\d{2}\/\d{2} \d{2}:\d{2} [APM]{2}$/.test(arg)) {
//     // MM/DD/YY hh:mm A
//     parsedDate = moment(arg, "MM/DD/YY hh:mm A");
//   } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(arg)) {
//     // MM/DD/YY (new condition for "10/12/25")
//     parsedDate = moment.utc(arg, "MM/DD/YY")
//   }
//   else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{6}Z$/.test(arg)) {
//     // ISO 8601
//     parsedDate = moment.utc(arg); // Already UTC
//   } else if (/^\d{4}-\d{2}-\d{2}$/.test(arg)) {
//     // YYYY-MM-DD
//     parsedDate = moment.utc(arg, "YYYY-MM-DD"); // Assume start of day in UTC
//   } else if (/^\d{2}-\d{2}-\d{4}$/.test(arg)) {
//     // MM-DD-YYYY
//     parsedDate = moment.utc(arg, "MM-DD-YYYY"); // Assume start of day in UTC
//   } else {
//     console.log("Unrecognized format:", arg);
//     return "-";
//   }

//   // Convert to America/New_York timezone
//   // const nyDate = parsedDate.tz("America/New_York");

//   // Format for display
//   // formattedDate = nyDate.format(DATE_FORMAT);
//   formattedDate = parsedDate.format(DATE_FORMAT);

//   // Console logs to see original vs converted
//   console.log("Original Input:     ", arg);
//   console.log("Parsed UTC Time:    ", parsedDate.format("YYYY-MM-DD hh:mm A"));
//   // console.log("New York Time (EST/EDT): ", nyDate.format("YYYY-MM-DD hh:mm A z"));

//   return formattedDate;
// };

// export default parseDate;


//-----------------comment 6 nov 2025---------------
// import moment from 'moment';
// import { DATE_FORMAT } from "src/config";

// const parseDate = (arg) => {
//   if (!arg) return "-";

//   let parsedDate;
//   let formattedDate;

//   // Detect format and parse accordingly
//   if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(arg)) {
//     // MM/DD/YYYY hh:mm:ss
//     parsedDate = moment(arg, "MM/DD/YYYY hh:mm:ss");
//   } else if (/^\d{2}\/\d{2}\/\d{2} \d{2}:\d{2} [APM]{2}$/.test(arg)) {
//     // MM/DD/YY hh:mm A
//     parsedDate = moment(arg, "MM/DD/YY hh:mm A");
//   } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(arg)) {
//     // MM/DD/YY (new condition for "10/12/25")
//     parsedDate = moment(arg, "MM/DD/YY");
//   } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{6}Z$/.test(arg)) {
//     // ISO 8601
//     parsedDate = moment(arg);
//   } else if (/^\d{4}-\d{2}-\d{2}$/.test(arg)) {
//     // YYYY-MM-DD
//     parsedDate = moment(arg, "YYYY-MM-DD");
//   } else if (/^\d{2}-\d{2}-\d{4}$/.test(arg)) {
//     // MM-DD-YYYY
//     parsedDate = moment(arg, "MM-DD-YYYY");
//   } else {
//     console.log("Unrecognized format:", arg);
//     return "-";
//   }

//   // Format for display
//   formattedDate = parsedDate.format(DATE_FORMAT);


//   return formattedDate;
// };

// export default parseDate;

import moment from 'moment';
import { DATE_FORMAT } from "src/config";

const parseDate = (arg) => {
  if (!arg) return "-";

  let parsedDate;
  let formattedDate;

  // Detect format and parse accordingly
  if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(arg)) {
    // MM/DD/YYYY hh:mm:ss
    parsedDate = moment(arg, "MM/DD/YYYY hh:mm:ss");
  } else if (/^\d{2}\/\d{2}\/\d{2} \d{2}:\d{2} [APM]{2}$/.test(arg)) {
    // MM/DD/YY hh:mm A
    parsedDate = moment(arg, "MM/DD/YY hh:mm A");
  } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(arg)) {
    // MM/DD/YY (e.g., "10/12/25")
    parsedDate = moment(arg, "MM/DD/YY");
  } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(arg)) {
    // NEW: DD/MM/YYYY (e.g., "14/05/2025") OR MM/DD/YYYY
    // Moment is lenient, but to be safe, try DD/MM/YYYY first
    parsedDate = moment(arg, "DD/MM/YYYY", true); // strict mode
    if (!parsedDate.isValid()) {
      parsedDate = moment(arg, "MM/DD/YYYY", true);
    }
  } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{6}Z$/.test(arg)) {
    // ISO 8601
    parsedDate = moment(arg);
  } else if (/^\d{4}-\d{2}-\d{2}$/.test(arg)) {
    // YYYY-MM-DD
    parsedDate = moment(arg, "YYYY-MM-DD");
  } else if (/^\d{2}-\d{2}-\d{4}$/.test(arg)) {
    // MM-DD-YYYY
    parsedDate = moment(arg, "MM-DD-YYYY");
  } else {
    console.log("Unrecognized format:", arg);
    return "-";
  }

  if (!parsedDate.isValid()) {
    console.log("Invalid date after parsing:", arg);
    return "-";
  }

  // Format for display
  formattedDate = parsedDate.format(DATE_FORMAT);

  return formattedDate;
};

export default parseDate;